// Notre objet récupère les méthodes de l'objet "history"
import { createBrowserHistory } from "history";
//On redéclare ensuite les méthodes
export default createBrowserHistory();